import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

const FAQS = [
  {
    q: "How much do I need to spend on ads?",
    a: "We recommend $500–$1,500/month to start. This is separate from the WAM program fee. The Sprint add-on covers 14 days of managed spend to stabilize your campaign.",
  },
  {
    q: "How fast will I see leads?",
    a: "Typically 48–72 hours after ads go live. Cassandra saw 221 leads in 10 days.",
  },
  {
    q: "Do I need to be good on camera?",
    a: "No. The webinar script is provided and tested. For Sprint clients, we offer in-person ad recording in Houston if needed.",
  },
  {
    q: "What loan types work best?",
    a: "Any niche with a specific borrower: VA, FHA first-time buyers, USDA rural, DSCR investors. Narrower = cheaper leads.",
  },
  {
    q: "Will my broker approve this?",
    a: "All ad copy and scripts are written compliance-first. We build in a broker review step before launch.",
  },
  {
    q: "What's included in the Sprint guarantee?",
    a: "If your first webinar doesn't produce at least one pre-qualified applicant, we continue managing your campaign at no additional charge until it does.",
  },
  {
    q: "What CRM do I need?",
    a: "GoHighLevel (GHL). If you don't have it, we can set up a sub-account. The WAM snapshot is installed directly.",
  },
  {
    q: "Is this a course or is it done for you?",
    a: "Done for you. We build the funnel, write the ads, install the CRM, and deliver the script. You show up and run the webinar.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section
      className="relative py-32 md:py-48 border-t wam-hairline"
      data-testid="faq-section"
    >
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="mb-8 flex items-center gap-4"
        >
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#F0ECE4]/40">
            [008] —
          </span>
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#C9A84C]">
            COMMON QUESTIONS
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="font-display max-w-[900px] mb-20"
          style={{ fontSize: "clamp(34px, 5vw, 78px)", lineHeight: 0.95, letterSpacing: "-0.035em" }}
        >
          The <span className="text-[#C9A84C]">honest</span> answers.
        </motion.h2>

        <ul>
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <motion.li
                key={f.q}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className="border-t wam-hairline"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="group flex w-full items-center gap-6 py-6 md:py-8 text-left transition-colors hover:bg-white/[0.02]"
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={isOpen}
                >
                  <span className="font-mono text-[11px] tracking-[0.24em] text-[#C9A84C] w-8 shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex-1 font-display text-[18px] md:text-[24px] tracking-[-0.02em]">
                    {f.q}
                  </span>
                  <motion.span
                    animate={{ rotate: isOpen ? 45 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-display text-[#C9A84C] text-[26px] leading-none shrink-0"
                  >
                    +
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <div className="pl-[3.5rem] pr-12 pb-8 font-body text-[15px] leading-[1.8] text-[#F0ECE4]/70 max-w-[720px]">
                        {f.a}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.li>
            );
          })}
          <li className="border-t wam-hairline" />
        </ul>
      </div>
    </section>
  );
}
